// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./static/js/" + chunkId + ".bundle.1793795453632.js";
};